<section modalContainer invisibleWhitespace>
    <app-modal-header header>이메일 입력</app-modal-header>
    <div class="p-4 flex flex-col gap-2">
        <app-hint>여러명에게 보낼 수 있습니다.</app-hint>
        <app-hint>입력 후 Enter를 누르면 이메일이 추가됩니다.</app-hint>
        <app-input-chip
            [(value)]="emails"
            placeholder="이메일을 입력해주세요."
        />
    </div>
    <div footer class="p-4">
        <app-button expand [disabled]="!emails()?.length" (click)="submit()"
            >완료</app-button
        >
    </div>
</section>
